import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

import { isRumConfigured } from '@/lib/datadog';

import { useCurrentUser } from '@/hooks/useApiKey';

/**
 * Tags the RUM session with the logged-in user so errors can be traced back to
 * a person. `username` is an email, so it maps to RUM's reserved `email`
 * attribute and renders natively as `usr.email`.
 */
export function useDatadogUser(): void {
    const [user] = useCurrentUser();
    const userId = user?.id;
    const username = user?.username;
    const name = user?.name;
    const teamId = user?.teamId;

    useEffect(() => {
        if (!isRumConfigured()) return;

        if (userId) {
            datadogRum.setUser({
                id: userId,
                name,
                email: username,
                teamId,
            });
        } else {
            datadogRum.clearUser();
        }
    }, [userId, username, name, teamId]);
}
